// Callback interface
/**
 * (): void | Promise<void>;
 */

// IntervalRegulator interface

/**
 * (iteration: number): number;
 */

/**
 * options: {callback: Callback; intervalRegulator?: IntervalRegulator;}
 */
export class RecursiveInterval {
  constructor(options) {
    const { intervalRegulator, callback } = options;
    this._callback = callback;
    this._intervalRegulator = intervalRegulator || (() => 5000);
  }

  _callback;
  _intervalRegulator;
  _private = null;
  _iteration = 0;
  _active = false;

  get active() {
    return this._active;
  }

  run() {
    this._active = true;
    const delay = this._intervalRegulator(this._iteration);

    this._timerId = setTimeout(() => {
      const res = this._callback();

      const nextAction = () => {
        if (this._active) {
          this._iteration++;
          this.run();
        }
      };

      if (res) {
        res.then(nextAction).catch(nextAction);
      } else {
        nextAction();
      }
    }, delay);
  }

  stop() {
    if (this._timerId) {
      this._active = false;
      clearTimeout(this._timerId);
      this._timerId = null;
    }
  }
}
